import React from 'react';
import { Text } from '@beef/ui-kit';

// components
import { ServiceItemLayout } from "../../../../../common/ServiceItemLayout";
export var InputWrapper = function InputWrapper(_ref) {
  var children = _ref.children,
    className = _ref.className,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(ServiceItemLayout, {
    className: className,
    "data-t-id": "components-InputWrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s",
    "data-t-id": "components-InputWrapper"
  }, label), children);
};